jQuery(window).on('load', function () {
    jQuery(document).find('.ph-gallery-wp-loading-icon').hide();
    jQuery(document).find('.ph-gallery-wp-loading-class').css('visibility', 'visible');
});



// WEBPACK FOOTER //
// ./scripts/util/loading.js